// URL shortening service using TinyURL
export class URLShortenerService {
  // TinyURL API endpoint (free, no auth required)
  private static tinyUrlEndpoint = 'https://tinyurl.com/api-create.php';

  static async shortenURL(originalURL: string, title?: string): Promise<string> {
    try {
      console.log('Attempting to shorten URL:', originalURL);
      
      // TinyURL API is simple - just pass the URL as a query parameter
      const apiUrl = `${this.tinyUrlEndpoint}?url=${encodeURIComponent(originalURL)}`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/plain'
        }
      });

      if (!response.ok) {
        console.error('TinyURL API error:', response.status, response.statusText);
        // Return original URL if shortening fails
        return originalURL;
      }

      const shortURL = await response.text();
      console.log('Shortened URL created:', shortURL);
      
      // TinyURL returns the shortened URL as plain text
      if (shortURL && shortURL.startsWith('https://tinyurl.com/')) {
        return shortURL.trim();
      } else {
        console.error('Unexpected response from TinyURL:', shortURL);
        return originalURL;
      }
    } catch (error) {
      console.error('Error shortening URL:', error);
      // Return original URL if shortening fails
      return originalURL;
    }
  }

  // Cache shortened URLs to avoid repeated API calls for the same URL
  private static urlCache = new Map<string, string>();

  static async getShortenedURL(originalURL: string, title?: string): Promise<string> {
    // Check cache first
    if (this.urlCache.has(originalURL)) {
      return this.urlCache.get(originalURL)!;
    }

    // Shorten URL and cache result
    const shortURL = await this.shortenURL(originalURL, title);
    if (shortURL !== originalURL) {
      this.urlCache.set(originalURL, shortURL);
    }
    
    return shortURL;
  }
}